import React from "react";
import { Card, CardBody, Row, Col, Label, Button, CardHeader, NavItem } from "reactstrap";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { Checkbox } from "react-inputs-validation";
import "../../styles/estilos.css";
import Page from "components/Page";


class CotizacionPymes3 extends React.Component {

  constructor(props) {
    super(props);
    const { handleNext, coberturas = [] } = this.props
    if (coberturas.length > 0)
      coberturas.sort(function (a, b) {
        if (a.secuencial > b.secuencial) return 1;
        if (b.secuencial > a.secuencial) return -1;
        return 0;
      });
    this.state = { coberturas };
  }

  handleClick = () => {
    const { coberturas } = this.state;
    let arrayCoberturas = []
    coberturas.forEach(({ obligatorio, checked, codigo, name, id }) => {
      if (obligatorio || checked) arrayCoberturas.push({ codigo, nombre: name, id })
    });

    console.log('coberturas..', arrayCoberturas)
    this.props.handleNext({ arrayCoberturas, visible: 4 })

  }
  actualizarArray = () => {
    let { coberturas = [], arrayCoberturas } = this.props
    for (let i = 0; i < coberturas.length; i++) {
      const existe = arrayCoberturas.find(({ id }) => id === coberturas[i].id)
      if (existe)
        coberturas[i] = { ...coberturas[i], checked: true }
    }
    coberturas.forEach(({ obligatorio, codigo, ...res }) => {
      console.log(res, codigo)
      if (obligatorio && codigo === 'incendioAliadas')
        this.props.fetchMaximos(codigo)
    })
  }
  componentDidMount() {
    this.actualizarArray()
  }

  componentDidUpdate(prevProps, prevState) {
    console.log('PROPS3', prevProps, this.props)
    if ((this.props.coberturas !== prevProps.coberturas) || (this.props.arrayCoberturas !== prevProps.arrayCoberturas)) this.actualizarArray()
  }

  render() {
    const { validate, coberturas } = this.state;
    const { handleNext, handleBack } = this.props

    console.log('COBERTURAS', coberturas)
    return (

      <Row>
        <Col xl={8} lg={10} md={11} className="div-align-center">
          <Card>

            <CardHeader> <h4 style={{ fontWeight: 'bold', }} className='mb-5'>Seleccione las coberturas deseadas </h4></CardHeader>
            <CardBody className='div-align-center' >

              <Row className="mb-5">
                <Col md={4} sm={12} >
                  <p style={{ fontWeight: "normal" }} >Seleccione las coberturas que desea realizar en sus ubicaciones</p>
                </Col>
                <Col md={8} sm={12}>
                  {coberturas && coberturas.map((item, i) => {
                    console.log(item.obligatorio)

                    const coberturaPadre = coberturas.find(cobertura => cobertura.codigo == item.dependiente)
                    const indexPadre = coberturaPadre ? coberturas.indexOf(coberturaPadre) : null
                    // if (item.obligatorio) {
                    //   this.props.fetchMaximos(coberturas[i].codigo)
                    // }
                    return (
                      <div>
                        {item.dependiente == '-' || (item.dependiente != '-' && indexPadre && coberturas[indexPadre].checked == true) ?
                          <Checkbox
                            key={`cobertura${item.id}`}
                            id={`cobertura${item.id}`} // Optional.[String].Default: "".  Input ID.
                            name={`cobertura${item.id}`}
                            // value={item.name} // Required.[String].Default: "".
                            validate={validate}
                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            checked={item.obligatorio || item.checked} // Required.[Bool].Default: false.
                            onChange={(res, e) => {
                              coberturas[i] = { ...coberturas[i], checked: item.obligatorio || res }
                              console.log('ON CHANGE')
                              //this.props.fetchMaximos(coberturas[i].codigo)

                              var coberturaHija = coberturas.find(cobertura => cobertura.dependiente == coberturas[i].codigo)
                              var indexHija = coberturas.indexOf(coberturaHija)

                              if (!res && coberturaHija) {
                                coberturas[indexHija] = { ...coberturas[indexHija], checked: item.obligatorio || res }
                              }
                              console.log('ON CHANGE2', coberturas.indexOf(coberturaHija))
                              this.setState({ coberturas })
                            }}

                            labelHtml={<div style={{ color: '#4a4a4a', marginTop: 2, fontWeight: 'bold', overflow: 'hide', whiteSpace: 'nowrap', }}> {item.name} <span style={{ color: '#c5c3c3', fontWeight: 400, fontSize: 13 }} >{item.obligatorio ? '( Campo Obligatorio )' : ''}</span> </div>} // Required.[Html].Default: none.
                            validationOption={{
                              name: 'cobertura', // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              //required: item.obligatorio, // Optional.[Bool].Default: true. To determin if it is a required field.
                            }}
                          />:null
                        }

                      </div>

                    );
                  })}

                </Col>
              </Row>
              <Row>
                <Col lg={6} md={6} sm={6} xs={6} className="mt-3">
                  <Button className="btn btn-detail-gray" onClick={() => handleBack(2)} style={{ display: "block", margin: "auto" }} >
                    <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"  REGRESAR"}
                  </Button>
                </Col>
                <Col lg={6} md={6} sm={6} xs={6} className="mt-3" >
                  <div className="div-align-rigth">
                    <Button className="btn btn-primary" onClick={() => this.handleClick()} style={{ display: "block", margin: "auto" }} >
                      <i className="fa fa-chevron-circle-right" aria-hidden="true" />{"  CONTINUAR"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = dispatch => {
  return {
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionPymes3)
);
